import { useMutation, useQueryClient } from '@tanstack/react-query';
import { proposalProjectApiConnect } from '../lib/api/proposalProjectApi.connect';
/**
 * Update a compliance requirement's status and metadata
 */ export function useUpdateRequirement(projectId) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async ({ requirementId, ...data })=>{
            await proposalProjectApiConnect.updateRequirementStatus(projectId, requirementId, data);
        },
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: [
                    'complianceMatrix',
                    projectId
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'shredView',
                    projectId
                ]
            });
        }
    });
}
